import { ColumnDef } from '@tanstack/react-table';

import { Activity } from '../../types';
import { DateTimeDisplay } from '../DateTimeDisplay';
import { ActivityCauserBadge } from './ActivityCauserBadge';

export const activitiesTableColumns: ColumnDef<Activity>[] = [
  {
    id: 'created_at',
    accessorKey: 'createdAt',
    header: 'Date',
    cell: ({ row }) => <DateTimeDisplay value={row.original.createdAt} />,
  },
  {
    accessorKey: 'causerType',
    header: 'User type',
    cell: ({ row }) => (
      <ActivityCauserBadge activityCauser={row.original.causerType} />
    ),
    enableSorting: false,
  },
  {
    accessorKey: 'causerName',
    header: 'User',
    cell: ({ row }) => row.original.causerName,
    enableSorting: false,
  },
  {
    accessorKey: 'description',
    header: 'Activity',
    cell: ({ row }) => row.original.description,
    enableSorting: false,
  },
];
